import React from "react";
import '../node_modules/bootstrap/dist/css/bootstrap.min.css'
import "./index.css"

const Frontpage=()=>{

    return(
            <>
        <div className="font-div text-center ">
         <p className=" ptag text-end">My name is</p>
                    <h1 className=" htag text-end">ARBAZ PASHA</h1>
                <h5 className="font-foot text-capitalize" >a Full stack developer</h5>
                <h5 className="font-foot text-capitalize mt-0" > software engineer</h5>
        </div>
        </>
    )
}

export default Frontpage